import React from 'react';
import { useNavigate } from 'react-router-dom';
import './error-pages.scss';

const ServiceUnavailablePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="error-page">
      <div className="error-page__card">
        <div className="error-page__brand">RealityCoach</div>

        <div className="error-page__icon">🔌</div>

        <h1 className="error-page__title">Service Temporarily Unavailable</h1>

        <p className="error-page__description">
          We're unable to connect to the RealityCoach service right now.
          This could be due to a network issue or scheduled maintenance.
          Please check your connection and try again.
        </p>

        <div className="error-page__actions">
          <button className="error-page__btn-primary" onClick={() => window.location.reload()}>
            Retry
          </button>
          <button className="error-page__btn-secondary" onClick={() => navigate('/')}>
            Go to Dashboard
          </button>
        </div>

        <div className="error-page__info-box error-page__info-box--warning">
          <p>
            Check your internet connection. If the problem continues, please
            contact your administrator.
          </p>
        </div>

        <p className="error-page__footer">Error code: 503 - Service Unavailable</p>
      </div>
    </div>
  );
};

export default ServiceUnavailablePage;
